import { useEffect, useRef, useState } from "react";
import { useInView, animate } from "framer-motion";

/**
 * Counts from `from` → `to` once when scrolled into view.
 * Supports plain numbers (e.g. 15) and string suffixes (e.g. "+", "K").
 */
export const CountUp = ({
  to,
  from = 0,
  duration = 1.6,
  suffix = "",
  prefix = "",
  className = "",
  decimals = 0,
  useGrouping = true,
  testId,
}) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-50px" });
  const [val, setVal] = useState(from);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(from, to, {
      duration,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setVal(v),
    });
    return () => controls.stop();
  }, [inView, from, to, duration]);

  const formatted =
    decimals > 0
      ? val.toFixed(decimals)
      : Math.round(val).toLocaleString("en-US", { useGrouping });

  return (
    <span ref={ref} data-testid={testId} className={className}>
      {prefix}
      {formatted}
      {suffix}
    </span>
  );
};

export default CountUp;
